import React, { useEffect, useState } from "react";
import Accordion from 'react-bootstrap/Accordion';
import Form from 'react-bootstrap/Form';
import { PlusIcon, Pencil, HSCrossIcon } from "../../../modules/default-svg";
import FillRing from "../../../components/controls/fillRing/FillRing";
import { REPORT_LAYOUTS, constrainInput, getFillRatio, useReportFonts } from "../../../helpers/textFit";
import style from "./ProgressTracker.module.scss";

const LINE_LAYOUT = REPORT_LAYOUTS.programFocusLine;

const Item = (props) => {
    const { title, maxLines, placeholder, item, kpi, period, updateStatus,disabled } = props;
    useReportFonts();
    const [createItem, setCreateItem] = useState(false);
    const [description, setDescription] = useState('');
    const [progressItems, setProgressItems] = useState([]);
    const [defaultItem, setDefaultItem] = useState('');
    const [editingIndex, setEditingIndex] = useState(null);
    const [editedValue, setEditedValue] = useState('');
    const containerRef = React.useRef(null);
    
    const handleEdit = (index) => {
        setEditingIndex(index);
        setEditedValue(progressItems[index]);
    };

    const handleDescription = (value) => {
        setDescription(prev => constrainInput(value, prev, LINE_LAYOUT));
    }
    const handleEditedValue = (value) => {
        setEditedValue(prev => constrainInput(value, prev, LINE_LAYOUT));
    }

    const handleConfirm = () => {
            const updated = progressItems.map((item, index) => {
                if (index === editingIndex) {
                    return editedValue;
                } else {
                    return item;
                }
            });
            setProgressItems(prev => [...updated]);         
        const updatedProgress = progressItems.map((item, index) => {
            if (index === editingIndex) {
                return editedValue;
            } else {
                return item;
            }
        }).join('\n');
        let desc = '';
        if (editingIndex !== null || editingIndex > 0) {
            desc = updatedProgress;
        } else {
            desc = updatedProgress ? `${updatedProgress} \n ${description}` : description;
        }
        const payload = {
            description: desc,
            kpi: kpi,
            period: period,
        }
        description && setProgressItems(prev => [...prev, description]);
        updateStatus(payload);
        setEditingIndex(null);
        setEditedValue('');
        setCreateItem(true);
    }

    const handleCancel = () => {
        setEditingIndex(null);
        setEditedValue('');
        item.description ? setDescription(item.description) : setDescription("");
    }

    useEffect(() => {
        setDescription('');
        setEditingIndex(null);
        setEditedValue('');
        setCreateItem(false);
        setDefaultItem(item);
    }, [item]);

    useEffect(() => {
        if (defaultItem) {
            const itemsArray = defaultItem.split("\n").map(i => i.trim());
            const filteredArray = itemsArray.filter(item => item.trim() !== '');
            setProgressItems(filteredArray)
        }
        else{
            setProgressItems([])
        }
    }, [defaultItem]);

    useEffect(() => {
        setDescription('');
    }, [progressItems]);

    useEffect(() => {
        setDescription('');
    }, [createItem]);

    const handleCreateRowClick = (e) => {
        setCreateItem(true); 
        setDescription('');
        const container = containerRef.current;
        if (!container) return;
    
        setTimeout(() => {
            const container = containerRef.current;
            if (!container) return;
    
            const input = container.querySelector('.inputFieldGroupMain input');
            if (input) {
                input.focus();
            }
        }, 0);
    };

    return (
        <>
            <Accordion defaultActiveKey="0" className={`accordianMainContainer accordian-setting ${disabled ? style.disabledContainer : ''}`}>
                <Accordion.Item eventKey="0">
                    <Accordion.Header>
                        {title}
                        <span className="accordiansmalltext text-xsm-500">
                            ({`${progressItems.length > 0 ? progressItems.length : 0}/${maxLines}`})
                        </span>
                    </Accordion.Header>
                    <Accordion.Body className="accordian-body-content" ref={containerRef}>
                        {progressItems.length > 0 ? (
                            progressItems.map((item, index) => (
                                <>
                                    <div key={index} className={`${index !== editingIndex ? 'EditedProgressWrap' : 'inputFieldGroupMain'}  d-flex align-items-center justify-content-between`}>
                                        <div className="w-100 position-relative">
                                            <Form.Control
                                                type="text"
                                                value={editingIndex === index ? editedValue : item}
                                                readOnly={index !== editingIndex}
                                                onChange={(e) => handleEditedValue(e.target.value)}
                                                onClick={() => handleEdit(index)}
                                                style={{ fontSize: "14px", fontFamily: 'Figtree-Regular' }}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        e.preventDefault();
                                                        handleConfirm();
                                                    }
                                                }}
                                            />
                                            {(index == editingIndex) && (
                                                <span className="AvatarColor inputCountWrap">
                                                    <FillRing ratio={getFillRatio(editedValue, LINE_LAYOUT)} />
                                                </span>
                                            )}
                                        </div>
                                        <button type="button" className="HoverEditBtn ms-1" onClick={() => handleEdit(index)}>
                                            <Pencil />
                                        </button>
                                        {!(index !== editingIndex) && (
                                            <>
                                                <button type="button" className="edit-btns" onClick={handleCancel}>
                                                    <HSCrossIcon />
                                                </button>
                                            </>
                                        )}
                                    </div>
                                </>
                            ))
                        ) : (
                            !createItem && <div className="accordianEmptyDiv">
                                <p className="accordianEmptyDivText">{placeholder}</p>
                            </div>
                        )}
                        {(!disabled && createItem && progressItems.length < maxLines) && (
                            <div className="inputFieldGroupMain d-flex align-items-center">
                                <div className="w-100 position-relative">
                                    <Form.Control
                                        type="text"
                                        placeholder=""
                                        value={description}
                                        style={{ fontSize: "14px", fontFamily: 'Figtree-Regular' }}
                                        onChange={((e) => handleDescription(e.target.value))}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                e.preventDefault();
                                                handleConfirm(); 
                                            }
                                        }}
                                    />
                                    <span className="AvatarColor inputCountWrap">
                                        <FillRing ratio={getFillRatio(description, LINE_LAYOUT)} />
                                    </span>
                                </div>
                                <button type="button" className="edit-btns" onClick={() => setCreateItem(false)}>
                                    <HSCrossIcon />
                                </button>
                            </div>
                        )}
                        {!disabled && progressItems.length < maxLines &&
                            <button type="button" className="create-now text-sm-500" onClick={handleCreateRowClick}>
                                <PlusIcon color="#342c82"/>
                                Create row
                            </button>
                            }
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </>
    );
}

export default Item;